import { render, staticRenderFns } from "./InputHakKelas.vue?vue&type=template&id=2714cd4c&scoped=true"
import script from "./InputHakKelas.vue?vue&type=script&lang=js"
export * from "./InputHakKelas.vue?vue&type=script&lang=js"
import style0 from "./InputHakKelas.vue?vue&type=style&index=0&id=2714cd4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2714cd4c",
  null
  
)

export default component.exports